export const PENDING = 'PENDING';
export const PENDING_MIXIN = { PENDING };

export const PW_QUERY_KEY = 'pw';
export const AUTH_CODE_KEY = 'code';

export const SAFE_SESSION_DELETE_REASON = 12;

export const PUBNUB_FRAME_INITIALIZED_EVENT_TYPE = 'PUBNUB_FRAME_INITIALIZED_EVENT_TYPE';
export const PUBNUB_COMMAND_EVENT_TYPE = 'PUBNUB_COMMAND_EVENT_TYPE';
export const PUBNUB_CALLBACK_TRIGGER_EVENT_TYPE = 'PUBNUB_CALLBACK_TRIGGER_EVENT_TYPE';

export const PUBNUB_INIT_EVENT_TYPE = 'PUBNUB_INIT_EVENT_TYPE';
export const PUBNUB_INIT_ERROR_TYPE = 'PUBNUB_INIT_ERROR_TYPE';
export const PUBNUB_ERROR_TYPE = 'PUBNUB_ERROR_TYPE';
export const PUBNUB_INIT_SUCCESS = 'PUBNUB_INIT_SUCCESS';

export const APP_VERSION_QUERY_NAME = 'appVersion';
